import React from 'react';
import Image from 'next/image';

interface IProps {
  name?: string;
  image?: string;
  username?: string;
}

const Avatar: React.FC<IProps> = ({ username, image, name }) => (
  <div className="flex flex-col gap-2">
    <div className="flex min-h-16 w-16 min-w-16 items-center justify-center overflow-hidden rounded-full border border-gray-200 bg-gray-50">
      <Image
        src={image || '/images/default-no-logo.webp'}
        alt={name?.slice(0, 1) || 'user profile avatar'}
        width={image ? 60 : 30}
        height={image ? 60 : 30}
        className="rounded-full object-contain"
        title="Kurs ishlab chiquvchining rasmi"
      />
    </div>
    <div className="flex flex-col">
      <span className="line-clamp-2 font-medium">{name}</span>
      <span className="line-clamp-1 text-xs text-gray-500">{username}</span>
    </div>
  </div>
);

export default Avatar;
